import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Rightbar from "./rightbar";
import { Context } from "../../context";
import Request from "../../core/httpClient";


const request = new Request();

export default function Header({ id, sidebar, nav, reload, change }) {
  const context = useContext(Context);

  const [user, setUser] = useState({
    idUsuario: 0,
    idPerfil: 0,
    idFraccionamiento: 0,
    idAdministracion: 0,
  });
  const [denied, setDenied] = useState(false);
  const [fraccionamientoNombre, setFraccionamientoNombre] = useState(localStorage.getItem("fracName"));
  const [hidden, setHidden] = useState(false);
  const [subfraccionamiento, setSubfraccionamiento] = useState(0);

  const logo =
    process.env.REACT_APP_NAME === "iGate"
      ? require("../../img/logo.png")
      : require("../../img/LogoWebAdministracionSmaller.png");


  useEffect(() => {
    setFraccionamientoNombre(localStorage.getItem("fracName"));
  }, [context.fracActual]);

  
  useEffect(() => {
    load();

    const location = [
      "/catalogos/subfraccionamientos",
      "/tablero",
      "/catalogos/presupuestos/concepto",
      "/administracion/areas/instalaciones",
      "/administracion/areas/reservacion",
      "/administracion/areas/historial",
      "/entornos",
      "/perfiles",
      "/users",
    ].includes(window.location.pathname);

    setHidden(location);

    if (document.getElementById("sidebar")) {
      document.getElementById("sidebar").classList.add("active");
      document.getElementById("sidebar").style.minWidth = "20%";
    }

    if (nav) {
      const el = document.getElementById(nav);
      if (el) el.classList.add("nav-active");
    }
  }, []);

 
  const openNav = () => {
    const sidebarEl = document.getElementById("sidebar");
    if (!sidebarEl) return;
    if (sidebarEl.classList.contains("active")) {
      sidebarEl.classList.remove("active");
      sidebarEl.style.minWidth = "0%";
    } else {
      sidebarEl.classList.add("active");
      sidebarEl.style.minWidth = "20%";
    }
  };

  const handleLogout = () => {
    context.logout();
    window.location = "/login";
  };

  const handleChange = (event) => {
    if (!event.target.value) return;
    setSubfraccionamiento(event.target.value);

    const data = {
      if: parseInt(document.getElementById("fraccionamiento").value),
      isf: parseInt(document.getElementById("subfrac").value),
    };
    localStorage.setItem("objectKey", JSON.stringify(data));
    reload();
    change();
  };

  async function load() {
    const userData = await context.loadUser();
    if (userData) {
      if (userData.auth) {
        setUser({
          idUsuario: userData.id.id_usuario,
          idPerfil: userData.id.id_perfil,
          idFraccionamiento: userData.id.id_fraccionamiento,
          idAdministracion: userData.id.id_administracion,
        });
      } else {
        context.logout();
        window.location = "/login";
      }
    }
  }

  const menuItems = [
    {
      id: "catalogos",
      icon: "fas fa-address-card",
      label: "Catálogos",
      loc: "submenu_loc",
      default: "/catalogos/subfraccionamientos",
    },
    {
      id: "administracion",
      icon: "fas fa-home",
      label: "Administración",
      loc: "submenu_loc_admin",
      default: "/catalogos/presupuestos/concepto",
    },
    {
      id: "operacion",
      icon: "fas fa-home",
      label: "Operación",
      loc: "submenu_loc_ope",
      default: "/administracion/emergencias",
    },
    {
      id: "reportes",
      icon: "fas fa-warehouse",
      label: "Reportes",
      default: "/reportes",
    },
  ];

  return (
    <>
      <header id={id || ""} className="justify-center header-slide">
        <div className="row full">
          <div className="options row align-center justify-center">
            <div className="logo align-center">
              <Link to="/tablero" className="responsive-img auto">
                <img src={logo} alt={`Logo ${process.env.REACT_APP_NAME}`} />
              </Link>
              <p className="font-large weight-medium color-white">
                &nbsp; {process.env.REACT_APP_NAME === "iGate" ? "iGate" : ""}
              </p>
            </div>
            {sidebar && <i className="fas fa-stream icon-main" onClick={openNav}></i>}
          </div>
          <div className="row full justify-end full ">
            <div className="justify-start align-center nav-size">
              <i className="fas fa-building color-white"></i>
              <p className="font-regular color-white full">&nbsp;{context.fraccionamiento}</p>
            </div>
            <nav className="align-center justify-end full">
              {denied ? (
                <button className="font-regular color-white" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt font-text" />Salir
                </button>
              ) : (
                <div className="row justify-end">
                  {menuItems.map((item) => (
                    <div className="nav-item auto text-center" id={item.id} key={item.id}>
                      <Link
                        to={localStorage.getItem(item.loc) || item.default}
                        className="font-regular color-white"
                      >
                        <i className={`${item.icon} font-text`} /> {item.label}
                      </Link>
                    </div>
                  ))}
                  <div className="nav-item auto">
                    <a
                      onClick={() => document.getElementById("rightsidebar")?.classList.toggle("open")}
                      href="#settings"
                      className="font-regular color-white"
                    >
                      <i className="fas fa-cogs font-text" />
                    </a>
                  </div>
                </div>
              )}
            </nav>
          </div>
        </div>
      </header>
      <Rightbar />
    </>
  );
}
